import { HHStack, HHTypography } from '@hinge-health/react-component-library';
import { useLocation } from 'react-router-dom';
import BillManagementGrid from '../components/bills/bill-management/bill-level/bill-management-grid';
import { ManagementViewToggle } from '../components/bills/bill-management/management-view-toggle';
import SubmissionManagementGrid from '../components/bills/bill-management/submission-level/submission-management-grid';
import { GridLevelName } from '../components/grid-components/grid-types';
import { routes } from '../constants/strings/routes';
import { DynamicDrawerProvider } from '../context/dynamic-drawer.context';

export const BILL_MANAGEMENT_TEST_ID = 'bill-management-container';

const BillManagement = (): JSX.Element => {
  const location = useLocation();

  // route based level identifier
  const isSubmissionManagement = location.pathname.includes(
    routes.billing.submissionsManagement,
  );
  const view: GridLevelName = isSubmissionManagement
    ? GridLevelName.SUBMISSION
    : GridLevelName.BILL;

  return (
    <DynamicDrawerProvider>
      <HHStack
        sx={{ paddingLeft: 6, paddingTop: 6 }}
        direction="row"
        alignItems="center"
        spacing={4}
      >
        <HHTypography hhVariant="section-title">
          {view === GridLevelName.BILL
            ? 'Bill Management'
            : 'Submission Management'}
        </HHTypography>
        <ManagementViewToggle currentView={view} />
      </HHStack>
      {view === GridLevelName.BILL ? (
        <BillManagementGrid />
      ) : (
        <SubmissionManagementGrid />
      )}
    </DynamicDrawerProvider>
  );
};

export default BillManagement;
